import React from 'react';
import Icon from '@ant-design/icons';

const TowerSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#53A5E0"
        d="M10 4.167A5.83 5.83 0 0 0 4.167 10h1.666C5.833 7.7 7.7 5.833 10 5.833S14.167 7.7 14.167 10h1.666A5.829 5.829 0 0 0 10 4.167Zm.833 7.741A2.085 2.085 0 0 0 12.083 10a2.084 2.084 0 0 0-4.166 0c0 .85.516 1.583 1.25 1.908v2.75L6.325 17.5 7.5 18.675l2.5-2.5 2.5 2.5 1.175-1.175-2.842-2.842v-2.75ZM10 .833C4.942.833.833 4.942.833 10H2.5a7.5 7.5 0 0 1 15 0h1.667c0-5.058-4.109-9.167-9.167-9.167Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

const TowerIconV2 = (props) => <Icon component={TowerSvg} {...props} />;

export default TowerIconV2;
